module.exports = __webpack_public_path__ + "static/savings_account_plan-d3ccad7740a57e2d61562de39a8853f1.pdf";